import { EXPERIMENTS } from 'Services/optimizely/optimizely.consts';

import { useOptimizelyDecision } from '../useOptimizelyDecision';

export const useSeenFilterExperimentation = () => {
	const { isEnabled } = useOptimizelyDecision({ experimentId: EXPERIMENTS.SEEN_VEHICLES_FILTER });
	return isEnabled;
};
